import React, { useEffect } from 'react'
import { useTranslation } from 'react-i18next'
import { KibContainer } from '@chewy/kib-layout-react'
import { NumberUtils } from '@pbt/pbt-ui-components'

import arrowImage from '~/components/common/images/arrowPaymentRequest.svg'
import catLaptopImage from '~/components/common/images/catLaptopPaymentRequest.svg'
import dogTerminalImage from '~/components/common/images/dogTerminalPaymentRequest.svg'
import {
  isTransactionCompleted,
  isTransactionError,
} from '~/constants/addPaymentDialogV2Constants'
import { usePaymentTransactionStatus } from '~/hooks/usePaymentTransactionStatus'

import { usePaymentDialog } from '../context/PaymentDialogProvider'

import '@chewy/kib-layout-styles/dist/styles/kib-container.css'
import styles from './PaymentRequestScreen.module.scss'

export const PaymentRequestScreen = () => {
  const { t } = useTranslation('Dialogs')
  const { dialogState, actions } = usePaymentDialog()
  const { paymentData } = dialogState
  const amountToCharge = parseFloat(paymentData.amountToCharge || '0')
  const { transaction, error } = usePaymentTransactionStatus(
    dialogState.paymentData.transactionId || '',
  )

  useEffect(() => {
    if (paymentData.transactionId && transaction) {
      if (isTransactionCompleted(transaction)) {
        actions.handleTransactionSuccess(paymentData)
      } else if (isTransactionError(transaction)) {
        actions.handleTransactionFailure()
      }
    } else if (paymentData.transactionId && error) {
      actions.handleTransactionFailure()
    }
  }, [paymentData.transactionId, transaction, error])

  return (
    <KibContainer className={styles.paymentRequestContainer}>
      <div className={styles.paymentRequestInfo}>
        <div className={styles.infoText}>
          {t('Dialogs:ADD_PAYMENT_DIALOG_V2.PAYMENT_REQUEST_INFO', {
            amount: `${NumberUtils.formatMoney(amountToCharge)}`,
            terminal: paymentData.paymentTerminal || '',
          })}
        </div>
        <div className={styles.instructionText}>
          {t('Dialogs:ADD_PAYMENT_DIALOG_V2.LOOK_FOR_TRANSACTION_ON_TERMINAL')}
        </div>
      </div>
      <div className={styles.paymentRequestImages}>
        <img
          alt="Cat with Laptop"
          className={styles.paymentImage}
          src={catLaptopImage}
        />
        <img alt="Arrow" className={styles.arrowImage} src={arrowImage} />
        <img
          alt="Dog with Terminal"
          className={styles.paymentImage}
          src={dogTerminalImage}
        />
      </div>
    </KibContainer>
  )
}
